import React, { Component } from 'react'
import querystring from 'query-string'
import { connect } from 'react-redux'

import { receiveItems, searchKeyword, clearItems, filterRole } from '../../../actions/setting/teamblog'
import TeamBlogListItem from './TeamBlogListItem';
import { parseListParams } from './TeamblogListHelper';
import {addPrefix} from "../../../utils/UriUtil";

@connect(state => ({
    items: state.teamblog.item.items,
    condition: state.teamblog.condition,
}), dispatch => ({
    handleReceiveItems: (items, totalCount) => {
        dispatch(receiveItems(items, totalCount))
    },
    handleSearch: (keyword) => {
        dispatch(searchKeyword(keyword))
    },
    handleRole: (role) => {
        dispatch(filterRole(role))
    },
    handleClearItems: () => {
        dispatch(clearItems())
    },
    dispatch
}))
class TeamBlogList extends Component {

    constructor(props, context) {
        super(props, context);

		let listParams = parseListParams(props.location.search)

        this.state = {
            currentPage: listParams.page,
            currentRole: listParams.role,
            currentSearchKeyword : listParams.searchKeyword,
        }
    }

    componentWillReceiveProps(nextProps) {

        const { currentPage, currentRole, currentSearchKeyword } = this.state;
		let listParams = parseListParams(nextProps.location.search)

        if (( currentPage != listParams.page ) || (currentRole != listParams.role) || (currentSearchKeyword != listParams.searchKeyword)){
            this.fetchTeamBlogs(listParams.page, listParams.role, listParams.searchKeyword );
            this.setState({
                currentPage: listParams.page,
                currentRole : listParams.role,
                currentSearchKeyword : listParams.searchKeyword,
            });
        }

    }

    componentWillUnmount() {
        this.props.handleClearItems();
    }

    fetchTeamBlogs(page, role, searchKeyword) {
        fetch(addPrefix("/manage/teamblog/members.json?") + querystring.stringify({
                page: page,
                role : role,
                searchKeyword: searchKeyword
            }), {
            method: 'GET',
            credentials: 'include'
        })
            .then(r => r.json())
            .then(data => {
                this.props.handleReceiveItems(data.items, data.totalCount);
                this.props.handleRole(role);
                this.props.handleSearch(searchKeyword);
                this.setState({
                    currentPage: page
                })
            })
            .catch(e => {
                this.props.handleReceiveItems([], 0)
            })
    }

    render() {
        const { items } = this.props;

        return (
            <div className="wrap_list">
                <ul className="list_post">
                    { this.renderItems(items) }
                </ul>
            </div>
        )
    }

    renderItems(items){

        if(items.length === 0 ){
            return this.renderEmptyItems();
        }else{
            return items.map(item =>
                <TeamBlogListItem key={item.userId} item={item} />
            )
        }
    }

    renderEmptyItems() {

        const { condition } = this.props;
        const { searchKeyword, role } = condition;
        if(searchKeyword === '' ) {

            if(role === '') {
                return <li className="info_none">
                    <div className="txt_none">
                        <span className="wrap_ico"><span className="ico_blog ico_post"/></span>
                        팀블로그 멤버를 찾을 수 없습니다.
                    </div>
                </li>
            }else{

                let roleLabel;
                switch(role) {
                    case 'owner':
                        roleLabel = '소유자';
                        break;
                    case 'manager':
                        roleLabel = '관리자';
                        break;
                    case 'editor':
                        roleLabel = '편집자';
                        break;
                    case 'writer':
                        roleLabel = '필자';
                        break;
                }
                return <li className="info_none">
                    <div className="txt_none">
                        <span className="wrap_ico"><span className="ico_blog ico_post"/></span>
                        {roleLabel} 팀블로그 멤버를 찾을 수 없습니다.
                    </div>
                </li>
            }
        }else{
            return <li className="info_none">
                <div className="txt_none">
                    <span className="wrap_ico"><span className="ico_blog ico_search"/></span>
                    검색 결과가 없습니다.
                </div>
            </li>
        }
    }
}

export default TeamBlogList;

